module.exports = __webpack_public_path__ + "img/system45-mini.12965bc1.png";